
import React, { useEffect, useState } from "react";
import API from "../Services/Product";

const ProductModal = ({ onSelectProduct, selectedActivityCenter, productId, type }) => {
    const [product, setProduct] = useState([]);
    const [selected, setSelected] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState({});

    useEffect(() => {
        const companyId = localStorage.getItem("company_id");
        if (companyId) {
            bindProduct();
        } else {
            setError({ locationId: "No company ID found in localStorage." });
        }
    }, [selectedActivityCenter]);

    const bindProduct = async () => {
        try {
            const CenterID = Array.isArray(selectedActivityCenter)
                ? selectedActivityCenter.join(",")
                : selectedActivityCenter;

            const payload = { location_id: CenterID };
            const response = await API.getLocationBaseProduct(payload);
            const fetchedProducts = response?.data?.data || [];

            setProduct(fetchedProducts);

            // ✅ Handle selected products when editing
            const selectedProductIds = typeof productId === "string"
                ? productId.split(",").map(id => id.trim())
                : [];

            const selectedFlags = fetchedProducts.map(prod =>
                selectedProductIds.includes(String(prod.id))
            );

            setSelected(selectedFlags);
            setSelectAll(selectedFlags.every(val => val === true));
        } catch (error) {
            console.error(error);
            if (error?.response?.status === 403) {
                window.location.replace("/Login");
            }
        }
    };

    const handleCheckboxChange = (id) => {
        const index = product.findIndex(p => p.id === id);
        if (index !== -1) {
            const updated = [...selected];
            updated[index] = !updated[index];
            setSelected(updated);
            setSelectAll(updated.every(val => val === true));
        }
    };

    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);
        setSelected(new Array(product.length).fill(checked));
    };

    const handleOk = () => {
        const selectedProductIds = product
            .map((prod, index) => (selected[index] ? prod.id : null))
            .filter(id => id !== null);

        if (selectedProductIds.length === 0) {
            setError({ locationId: "Please select at least one product." });
            return;
        }

        setError({});
        if (onSelectProduct) {
            onSelectProduct(selectedProductIds);
        }
        setShowModal(false);
    };

    const handleReset = () => {
        setSelected(new Array(product.length).fill(false));
        setSelectAll(false);
    };

    return (
        <section>
            <label>
                Product Name <span style={{ color: "red" }}>*</span>
            </label>
            <div className="dropdown">
                <button
                    className="btn dropdown-toggle form-control text-start"
                    type="button"
                    onClick={() => setShowModal(true)}
                >
                    {(() => {
                        const selectedProducts = product
                            .filter((_, index) => selected[index])
                            .map(prod => prod.name);
                        if (selectedProducts.length === 0) return "Select Products";
                        if (selectedProducts.length === 1) return selectedProducts[0];
                        return `${selectedProducts[0]}... (+${selectedProducts.length - 1})`;
                    })()}
                </button>
                {error.locationId && (
                    <small className="text-danger">{error.locationId}</small>
                )}
            </div>

            {showModal && (
                <div
                    className="modal fade show d-block"
                    tabIndex={-1}
                    style={{ background: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Select Products</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowModal(false);
                                        setError({});
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="container ms-3 me-2">
                                    <div className="row mb-2">
                                        <div className="col-md-3">
                                            <div className="form-check d-flex align-items-center">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="select-all"
                                                    checked={selectAll}
                                                    onChange={handleSelectAll}
                                                    style={{ boxShadow: "0 0 0 1px blue" }}
                                                />
                                                <label
                                                    htmlFor="select-all"
                                                    className="form-check-label ms-2"
                                                    style={{ userSelect: "none", cursor: "pointer" }}
                                                >
                                                    Select All
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {product.map((prod, index) => (
                                            <div className="col-md-3 mb-2" key={prod.id}>
                                                <div className="form-check d-flex align-items-center">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={`prod-${index}`}
                                                        checked={!!selected[index]}
                                                        onChange={() => handleCheckboxChange(prod.id)}
                                                        style={{ boxShadow: "0 0 0 1px blue" }}
                                                    />
                                                    <label
                                                        htmlFor={`prod-${index}`}
                                                        className="form-check-label ms-2"
                                                        style={{ userSelect: "none", cursor: "pointer" }}
                                                    >
                                                        {prod.name}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowModal(false);
                                        setError({});
                                    }}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleOk}
                                >
                                    Ok
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default ProductModal;
